import useTranslation from 'next-translate/useTranslation';

// Hooks
import useActiveGroup from '@/utils/hooks/user/useActiveGroup';

// Components
import { DefaultAvatar as Avatar } from '@/components/base/Avatar';

const HeaderGroupAnalytics = () => {
    const { t } = useTranslation();
    const { activeGroup } = useActiveGroup();

    return (
        <div className="flex h-12 w-full items-center space-x-3 overflow-hidden rounded-md border border-white bg-white/30 px-2 backdrop-blur-lg dark:border-icoDarkMode-beton dark:bg-icoDarkMode-deepBlack/30 sm:w-auto sm:min-w-[200px] sm:max-w-[350px] lg:px-2">
            <Avatar
                size="md"
                radius="rounded-md"
                fallback={activeGroup.name.substring(0, 2)}
                url={activeGroup.image}
                customColorClass={activeGroup.fallback_style}
            />
            <div className="space-y-0.5 overflow-hidden">
                <h1 className="truncate text-sm">{activeGroup.name}</h1>
                <p className="truncate text-xs text-icoGray-500 dark:text-icoDarkMode-wolf">
                    {t('commons:social_profiles_count', {
                        count: activeGroup.social_profiles?.filter(
                            (social_profile) => social_profile.active
                        ).length
                    })}
                </p>
            </div>
        </div>
    );
};

export default HeaderGroupAnalytics;
